import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  OutlinedInput,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { ChangeEvent, memo, useState } from "react";
import { Control, Controller, UseFormMethods } from "react-hook-form";
import { useSelector } from "react-redux";

import { withError } from "../HOC";
import { CommonFormElProps } from "../types";

import styles from "./SelectCity.module.scss";

export type SelectCityItem = {
  value: string;
  label: string;
};

export type SelectCityProps = {
  readonly control: Control;
  readonly items: Array<SelectCityItem>;
  readonly trigger: UseFormMethods["trigger"];
  readonly selectAvailableCities: any;
} & CommonFormElProps;

export const SelectCity = memo<SelectCityProps>(
  ({
    control,
    defaultValue,
    disabled: isDisabled,
    hasError,
    id,
    items,
    label,
    required = false,
    trigger,
    selectAvailableCities,
  }) => {
    // const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    //   setValues({...values, country: event.target.value});
    // };
    const [otherCityAvailability, setOtherCityAvailability] = useState(false);
    const cities = useSelector(selectAvailableCities) as {
      label: string;
      value: string;
    }[];

    return (
      <FormControl>
        <InputLabel
          shrink
          disabled={isDisabled}
          required={!isDisabled && required}
        >
          {label}
        </InputLabel>
        <div className={styles.container}>
          {cities.length > 0 && !otherCityAvailability ? (
            <Controller
              className={styles.controller}
              name={id}
              control={control}
              defaultValue={defaultValue}
              render={({ onChange, value }) => (
                <MuiSelect
                  className={styles.controller}
                  disabled={isDisabled}
                  error={hasError}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    onChange(selectedValue);
                  }}
                  id={id}
                  variant="outlined"
                  value={value}
                >
                  {cities.map(({ label, value }) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </MuiSelect>
              )}
            />
          ) : (
            <Controller
              name={id}
              control={control}
              className={styles.controller}
              defaultValue={defaultValue}
              as={
                <OutlinedInput
                  autoComplete="off"
                  defaultValue={defaultValue}
                  disabled={isDisabled}
                  error={hasError}
                  id={id}
                  inputProps={{
                    name: id,
                  }}
                />
              }
            ></Controller>
          )}
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={otherCityAvailability}
                onChange={() => setOtherCityAvailability((prev) => !prev)}
              />
            }
            label="Inne"
          />
        </div>
      </FormControl>
    );
  }
);

export const SelectCityWithError = withError(SelectCity);
